'use strict';

angular.module('schoolLinqApp').factory('positivePayService', [
	'$http',
	function ($http) {
		var endpoint = '/api/bank/positivepay';

		function getFields() {
			return $http.get(endpoint + '/fields');
		}

		function getSetup(id) {
			return $http.get(endpoint + '/' + id);
		}

		function postSetup(values) {
			return $http.post(endpoint, values);
		}

		function getBanks() {
			return $http.get(endpoint + '/banks');
		}

		function postFile(values) {
			return $http.post(endpoint + '/file', values);
		}

		return {
			getFields: getFields,
			getSetup: getSetup,
			postSetup: postSetup,
			getBanks: getBanks,
			postFile: postFile,
		};
	},
]);
